<template>
  <div>
    <div class="fl-sym-bg-primary fl-sym-text-white">
      <!-- REMINDER - this comp (choose-common.vue) can't use the TopHeader comp since it uses emit on click. Will resolve this when I merge TopHeader into the main index -->
      <div class="fl-sym-p-5 fl-sym-relative" @click="$emit('onBack')">
        <div
            class="fl-sym-absolute fl-sym-inset-y-0 fl-sym-left-0 fl-sym-flex fl-sym-justify-center fl-sym-items-center fl-sym-pl-4 fl-sym-text-4xl fl-sym-text-white hover:fl-sym-text-opacity-75">
          <img
              src="@/assets/chevron-left-thin.svg"
              width="15"
              class="chevron-left-thin"
          />
        </div>
        <img
            alt="felcana-symptom-checker-logo"
            src="@/assets/logo.svg"
            @click="goHome"
            width="147"
            class="fl-sym-mx-auto fl-sym-cursor-pointer"
        />
      </div>

      <div class="fl-sym-p-2">
        <div class="fl-sym-h-3 progress-bar">
          <div class="progress" id="progress"></div>
        </div>
      </div>

      <div class="fl-sym-text-white fl-sym-p-5 fl-sym-mt-16 question-styling">
        <p class="fl-sym-text-3xl fl-sym-font-bold fl-sym-mb-1">
          {{ session.question }}
        </p>
        <p
            class="fl-sym-text-2xl fl-sym-font-bold fl-sym-mb-1 fl-sym-leading-relaxed "
            v-if="session.question_details"
        >
          {{ session.question_details }}
        </p>
      </div>
    </div>


    <div class="fl-sym-p-2">
      <h3 @click="showModal=true"
          class="fl-sym-text-2xl fl-sym-leading-tight fl-sym-mb-3 fl-sym-font-medium fl-sym-mt-1 fl-sym-text-primary fl-sym-font-roboto">
        <img alt="felcana-symptom-checker" src="@/assets/Info-blue.png" width="15"
             class="info-icon-next fl-sym-inline"/> What does this mean?
      </h3>
      <div class="fl-sym-w-full fl-sym-left-0 fl-sym-py-10 fl-sym-px-2">
        <div class="fl-sym-mt-20">
          <button
              v-for="answer in session.answers"
              :key="answer.answer"
              class="fl-sym-w-full fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 hover:fl-sym-border-primary fl-sym-transition-all fl-sym-transition fl-sym-duration-300 fl-sym-ease-out"
              @click="$emit('onAnswer', answer)"
          >
            {{ answer.answer }}
          </button>
        </div>
        <div class="fl-sym-text-center">
          <span
              class="fl-sym-mx-auto fl-sym-font-semibold fl-sym-text-primary fl-sym-text-sm hover:fl-sym-text-opacity-75 fl-sym-cursor-pointer"
              @click="$emit('onBack')"
          >
            Back
          </span>
        </div>
      </div>
    </div>


    <modal v-if="showModal" @close="showModal = false">
      <template slot="body">
        <div class="fl-sym-px-2">
          <div class="fl-sym-text-master">
            {{
              session.what_does_this_means
                  ? session.what_does_this_means
                  : "Painful dogs may be more irritable, vocal or anxious."
            }}
          </div>
          <div class="fl-sym-mt-5 fl-sym-mb-16">
            <button
                class="fl-sym-w-full fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-5 hover:fl-sym-border-primary fl-sym-transition-all fl-sym-transition fl-sym-duration-300 fl-sym-ease-out"
                @click="showModal = false"
            >
              Ok, I understand. I can answer the question
            </button>
            <button
                class="fl-sym-bg-graduate fl-sym-p-4 fl-sym-rounded-full fl-sym-text-intermediate fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
                @click="showModal = false"
            >
              I do not understand. Let's skip for now
            </button>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<style>
.info-icon-next {
  position: relative;
  bottom: 2px;
  margin-right: -3px;
}

.question-styling {
  height: 28vh;
  vertical-align: bottom;
  display: table-cell;
}
</style>

<script>
import {mapState} from "vuex"
import Modal from "@/components/modal"

export default {
  data() {
    return {
      showModal: false,
      current_percentage: 0,
    }
  },
  computed: {
    ...mapState({
      answer: (state) => state.sc.answer,
    }),
  },
  components: {
    Modal,
  },
  props: {
    session: {
      default: null,
      type: Object,
    },
  },
  mounted: function () {
    this.$nextTick(this.move())
  },
  updated: function () {
    this.$nextTick(this.move())
  },
  methods: {
    move() {
      var elem = document.getElementById("progress")
      var width = this.current_percentage
      var percentage = this.session.percentage_done //will need to be changed to questions current percentage
      var id = setInterval(frame, 10)
      let component = this

      function frame() {
        if (width === percentage) {
          clearInterval(id)
          component.current_percentage = width
        } else if (width < percentage) {
          width++
          elem.style.width = width + "%"
        } else {
          width--
          elem.style.width = width + "%"
        }
      }
    },
  },
}
</script>
